/* src/app/views/dashboard/components/sidebar-nav/nav-item/current-location-nav-item/current-location-nav-item.component.scss */
.current-loc-nav-item-container {
  display: contents !important;
}
/*# sourceMappingURL=current-location-nav-item.component.css.map */
